<script setup lang="ts">
import { computed } from 'vue'
import { ElRate } from 'element-plus'

/**
 * A read-only star rating. The backend scores out of ten and the widget shows five
 * stars, so a half star is a real value rather than a rounding artefact.
 */
const props = withDefaults(
  defineProps<{
    modelValue?: number
    max?: number
  }>(),
  { modelValue: 0, max: 5 }
)

const score = computed(() => (Number(props.modelValue) || 0) / 2)
</script>

<template>
  <ElRate
    class="shared-rating"
    :model-value="score"
    :max="max"
    disabled
    allow-half
  />
</template>

<style lang="scss" scoped>
.shared-rating {
  height: auto;
  line-height: 1;
}
</style>
